export default "__VITE_ASSET__4b43ac78__"